import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Order } from '../../models/orders.model';
import { NgProgress } from 'ngx-progressbar';
import { MyoderService } from '../shared/myoder.service';
import { NgProgressService } from '../../services/ngProgress.service';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-back-orders',
  templateUrl: './back-orders.component.html',
  styleUrls: ['./back-orders.component.css']
})
export class BackOrdersComponent implements OnInit {

  title = 'BACK ORDERS';

  orders: Order[];
  setFullWindow: boolean = false;
  //Pagination
  p: number = 1;
  itemsPerPage: number = 30;
  totalItems: number;
  showPager: boolean = false;

  //search
  searchField:string;

  constructor(
    private router: Router,
    private orderService: MyoderService,
    public ngProgress: NgProgressService
  ) { }

  ngOnInit() {

    this.ngProgress.start();
    this.orderService.getBackOrder(this.p).subscribe((value: Order[]) => {
      this.totalItems = value.length;
      this.orders = value;
      this.showPager = true;
      this.ngProgress.done();
      // $('.page-contents').animate({ scrollLeft: $('#levelOne').width() }, 400);
    },
      (error: any) => console.info(error.error.responseMessage));
  }

  renderPagingOrder(event) {
    this.ngProgress.start();
    this.orderService.getBackOrder(event).subscribe((value: Order[]) => {
      this.p = event;
      this.orders = value;
      console.info(this.orders);
      this.ngProgress.done();
    },
      (error: any) => console.info(error));
  }

  searchOrder():void{
    this.orderService.monitorSearchKeyWordChange(this.searchField);
    this.router.navigateByUrl("/myOrder/searchorders");
  }
  
  watchOrder(order: Order): void {
    this.orderService.monitorOrderDetaiChange(order);
  }
}
